import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import type { OnInit } from '@angular/core';
import { LazyImgDirective } from '@core-mkt/services/lazy-load/lazy-load.directive';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { EnvService } from '@core-mkt/services/env/env.service';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import type { ModalContent } from './ambassador-data';
import { modalContentData } from './ambassador-data';

@Component({
  selector: 'ambassador-modal',
  templateUrl: './ambassador-modal.component.html',
  styleUrls: ['./ambassador-modal.component.scss'],
  standalone: true,
  imports: [FontAwesomeModule, LazyImgDirective],
})
export class AmbassadorModalComponent implements OnInit {
  trigger: boolean;
  faTimes = faTimes;
  modalData: ModalContent;
  brandConfiguration: string;

  constructor(
    private route: ActivatedRoute,
    private env: EnvService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  ngOnInit(): void {
    this.brandConfiguration = this.env.get.brandConfig.id.toLocaleLowerCase();
    this.modalData = this.resolveContent(modalContentData[this.brandConfiguration]);
    // Browser only: the copy depends on the clock, so a server render could disagree with the
    // browser's re-render and flash the wrong copy until JS boots.
    if (this.modalData && isPlatformBrowser(this.platformId)) {
      const amb = this.route.snapshot.queryParamMap?.get('campaignid');
      if (amb === this.modalData.ambassadorCampaign) {
        this.trigger = true;
      }
    }
  }

  private resolveContent(entry: ModalContent): ModalContent {
    const sale = entry?.saleOverride;
    const now = Date.now();
    // Checks "inside the window" so an unparseable date (NaN) falls back to the default copy.
    if (sale && now >= Date.parse(sale.start) && now < Date.parse(sale.end)) {
      return { ...entry, modalTitle: sale.modalTitle, modalContent: sale.modalContent };
    }
    return entry;
  }

  private toggleModal(): void {
    this.trigger = !this.trigger;
  }
}
